import { render } from "./BannerCarousel.vue?vue&type=template&id=33dbf118&ts=true"
import script from "./BannerCarousel.vue?vue&type=script&lang=ts"
export * from "./BannerCarousel.vue?vue&type=script&lang=ts"

import "./BannerCarousel.vue?vue&type=style&index=0&id=33dbf118&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__